import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import {withStyles, Badge} from '@material-ui/core';
import {toAbsoluteUrl} from "../../../../_helpers";

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: 12,
        top: 15,
        padding: '0 4px',
    },
}))(Badge);

const CollaborateMessagesToggler = () => {
    const [counter, setCounter] = useState(Math.floor(Math.random() * 100));

    useEffect(() => {
        function refresh() {
            setCounter(Math.floor(Math.random() * 110))
        }

        const interval = setInterval(refresh, 3000)

        return () => clearInterval(interval);
    }, [])

    return (
        <StyledBadge badgeContent={counter} color="error">
            <div className="topbar-item">
                <div className="btn btn-icon btn-topbar btn-lg mr-1"
                     id="od_quick_panel_toggle">
                        <span className="svg-icon svg-icon-xl svg-icon-white">
                        <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Group-chat.svg")}/>
                        </span>
                </div>
            </div>
        </StyledBadge>
    );
}

export default CollaborateMessagesToggler;
